import React from 'react';
import { Link } from 'react-router-dom';
export const Footer = () => {
  const footerSections = [{
    title: 'Platform',
    links: [{
      name: 'Developers',
      path: '/developers'
    }, {
      name: 'Freelancers',
      path: '/developers/freelancers'
    }, {
      name: 'Teams',
      path: '/teams'
    }, {
      name: 'Jobs',
      path: '/jobs'
    }]
  }, {
    title: 'Company',
    links: [{
      name: 'About',
      path: '/about'
    }, {
      name: 'Affiliates',
      path: '/affiliates'
    }]
  }, {
    title: 'External',
    links: [{
      name: 'Newsletter',
      path: 'https://newsletter.example.com'
    }]
  }, {
    title: 'Legal',
    links: [{
      name: 'Privacy Policy',
      path: '/privacy-policy'
    }, {
      name: 'Terms of Service',
      path: '/terms-of-service'
    }]
  }];
  return <footer className="bg-white" data-id="element-76">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-77">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8" data-id="element-78">
          {footerSections.map(section => <div key={section.title} data-id="element-79">
              <h3 className="text-sm font-semibold text-gray-900 uppercase tracking-wider mb-4" data-id="element-80">
                {section.title}
              </h3>
              <ul className="space-y-3" data-id="element-81">
                {section.links.map(link => <li key={link.name} data-id="element-82">
                    {link.path.startsWith('http') ? <a href={link.path} className="text-base text-gray-600 hover:text-[#d73b3e] transition-colors duration-200" target="_blank" rel="noopener noreferrer" data-id="element-83">
                        {link.name}
                      </a> : <Link to={link.path} className="text-base text-gray-600 hover:text-[#d73b3e] transition-colors duration-200" data-id="element-84">
                        {link.name}
                      </Link>}
                  </li>)}
              </ul>
            </div>)}
        </div>
        <div className="mt-12 pt-8 border-t border-gray-100" data-id="element-85">
          <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-86">
            <p className="text-base text-gray-500" data-id="element-87">
              &copy; {new Date().getFullYear()} CertifiedDevs. All rights
              reserved.
            </p>
            <div className="mt-4 md:mt-0 flex space-x-6" data-id="element-88">
              <a href="#" className="text-gray-400 hover:text-[#d73b3e] transition-colors duration-200" data-id="element-89">
                <span className="sr-only" data-id="element-90">Facebook</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-91">
                  <path fillRule="evenodd" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z" clipRule="evenodd" data-id="element-92" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#d73b3e] transition-colors duration-200" data-id="element-93">
                <span className="sr-only" data-id="element-94">Twitter</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-95">
                  <path d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84" data-id="element-96" />
                </svg>
              </a>
              <a href="#" className="text-gray-400 hover:text-[#d73b3e] transition-colors duration-200" data-id="element-97">
                <span className="sr-only" data-id="element-98">GitHub</span>
                <svg className="h-6 w-6" fill="currentColor" viewBox="0 0 24 24" data-id="element-99">
                  <path fillRule="evenodd" d="M12 2C6.477 2 2 6.484 2 12.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0112 6.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0022 12.017C22 6.484 17.522 2 12 2z" clipRule="evenodd" data-id="element-100" />
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>;
};